import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DropdownOptions from "../../../../../constants/DropdownOptions";
import { commVariertyLstAction, deleteCommVarietyAction, editCommVarietyAction } from "../../../../../modules/commvarieties/action";
import AllMainFarmSelectedDialog from "../../../../Common/AllMainFarmSelectedDialog";
import { isSuperAdmin } from "../../../../Common/CheckAuthorization";
import TabHeaderAndButton from "../../../../Common/TabHeaderAndButton";
import CreateTable from "../../../../CreateTable";
import ConfirmationDialog from "../../../../FormElement/ConfirmationDialog";
import Loader from "../../../../Loader";



class CommVarietyView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false,
      headerRows: {
        updatedAt: "Last Updated",
        updatedBy: "Updated By",
        name: "Name",
        variety: "Variety",
        lbsPerBushel: "lbs Per Bushel"
      },
      order: "desc",
      orderBy: "id"
    };
  }

  componentDidMount() {
    const { commVariertyLstAction, selectedYear } = this.props;
    if(!isSuperAdmin() || this.props.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id) {
      commVariertyLstAction( selectedYear);
    }  
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.rowCommodity &&
      this.props.rowCommodity !== nextProps.rowCommodity &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }
    if (this.props.MainFarmId !== nextProps.MainFarmId &&
      nextProps.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id) {
        this.props.commVariertyLstAction(this.props.selectedYear);
      }
    if (nextProps.selectedYear && nextProps.selectedYear !== this.props.selectedYear &&
      (!isSuperAdmin() || nextProps.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id)) {
      this.props.commVariertyLstAction(nextProps.selectedYear);
    }
  }

  deleteRow = id => {
    this.setState({
      open: true,
      id: id
    });
  };

  handleClose = () => {
    this.setState({
      open: false
    });
  };

  handleOk = () => {
    const { id } = this.state;
    this.handleClose();
    this.props.deleteCommVarietyAction(id);
  };

  editRow = id => {
    const { rowCommodity } = this.props;
    const requiredData = rowCommodity.find(
      commVariety => commVariety.id === id
    );
    console.log(requiredData);
    this.props.editCommVarietyAction(requiredData);
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };

  render() {
    const { rowCommodity } = this.props;
    console.log(rowCommodity,"rowComm");
    const { fetchingComplete, order, orderBy, open } = this.state;
    const prevPath = "farmsetup/farminformation",
      currentPage = "/commodity-varieties";
    return (
      <div className="ticket-body">
        <ConfirmationDialog
          open={open}
          handleClose={this.handleClose}
          handleOk={this.handleOk}
        />
        <TabHeaderAndButton
          header="Commodity varities"
          path={`/${prevPath}${currentPage}/create`}
          btnLabel="New commodity variety"
          isDisabled={isSuperAdmin() && this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id}

        />
        {isSuperAdmin() && this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id ? (
          <AllMainFarmSelectedDialog/>
        ) : (
            <div>
              {fetchingComplete ? (
                <CreateTable
                  order={order}
                  orderBy={orderBy}
                  headerRows={this.state.headerRows}
                  rowData={rowCommodity}
                  delete={this.deleteRow}
                  location={`${prevPath}${currentPage}/edit`}
                  edit={this.editRow}
                  onRequestSort={this.handleRequestSort}
                />
              ) : (
                <Loader />
              )}
            </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    rowCommodity: state.commVarReducer.commVarList,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    selectedYear: state.harvestYearReducer.selectedYear
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { commVariertyLstAction, deleteCommVarietyAction, editCommVarietyAction },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommVarietyView);



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/CommodityVarietes/CommVarietyView.js